module.exports = __webpack_public_path__ + "img/AmigosAAT.1a2ed6a9.png";